var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#00DCEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#00DCEC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#00DCEC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#00DCEC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 21,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#00DCEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerAzul);
export default __webpack_public_path__ + "static/media/Divider_Azul.b6a25c2f77917e5d5d502ec308b1f298.svg";
export { ForwardRef as ReactComponent };